import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import moment from 'moment'
import {Form, Row, Col, DatePicker, Button, Tabs, Input, Select} from 'antd'
import {SearchOutlined, DownloadOutlined} from '@ant-design/icons'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import UPM from '../../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

const storage = window.localStorage
const {RangePicker} = DatePicker
const {TabPane} = Tabs
const {TextArea} = Input

@inject('messageManagementStore', 'mappingManagementStore', 'uiState')
@observer
class SearchForm extends Component {
  state = {
    inboundValue: '',  //inboundName disable status
    outboundValue: '', //outboundName disable status
  }
  formRef = React.createRef()

  componentDidMount() {
    const {messageManagementStore, mappingManagementStore, searchParams} = this.props
    //get outbound type list
    mappingManagementStore.onGetoutboundCustomerAction()
    //get inbound type list
    mappingManagementStore.onGetinboundCustomerAction()
    //if goBack enter
    if (searchParams !== undefined) {
      //status tabsValue===searchParams
      messageManagementStore.changeTabsValue(searchParams.tabsValue)
      if (searchParams.tabsValue === 'APIInformationSearch') {
        const params = {
          inboundCustomer: searchParams?.inboundCustomer,
          inBoundName: searchParams?.inBoundName,
          outboundCustomer: searchParams?.outboundCustomer,
          outBoundName: searchParams?.outBoundName,
          startTime: searchParams?.startTime,
          endTime: searchParams?.endTime,
        }
        this.formRef.current.setFieldsValue({
          ...params,
          createDate: [moment(searchParams.startTime), moment(searchParams.endTime)]
        })
        this.setState({
          inboundValue: searchParams?.inboundCustomer,
          outboundValue: searchParams?.outboundCustomer,
        })
        messageManagementStore.searchMessageOverview(params, 1, PAGE_SIZE_DEFAULT)
      } else if (searchParams.tabsValue === 'identificationSearch') {
        const params = {
          messageId: searchParams?.messageId,
          requestId: searchParams?.requestId,
          // sapMessageId: searchParams?.sapMessageId,
        }
        this.formRef.current.setFieldsValue({
          messageId: params.messageId.join(','),
          requestId: params.requestId.join(','),
          // sapMessageId: params.sapMessageId.join(','),
        })
        messageManagementStore.searchMessageOverviewIdentification(params, 1, PAGE_SIZE_DEFAULT)
      } else {
        const params = {
          indexName: searchParams?.indexName,
          value: searchParams?.value,
          startTime: searchParams?.startTime,
          endTime: searchParams?.endTime,
        }
        this.formRef.current.setFieldsValue({
          ...params,
          createDateIndex: [moment(searchParams.startTime), moment(searchParams.endTime)]
        })
        messageManagementStore.searchMsgOverviewIndexName()
        messageManagementStore.searchMessageOverviewIndex(params, 1, PAGE_SIZE_DEFAULT)
      }
    } else {
      //date value is today
      this.formRef.current.setFieldsValue({
        createDate: [moment().startOf('day'), moment().endOf('day')],
        createDateIndex: [moment().add('day', -6).startOf('day'), moment().endOf('day')]
      })
      messageManagementStore.changeTabsValue('APIInformationSearch')
      //if menu enter
      this.handleSearch('APIInformationSearch')
    }
  }

  /*search button*/
  handleSearch = (tabsValue) => {
    const {messageManagementStore} = this.props
    if (tabsValue === 'APIInformationSearch') {
      this.formRef.current.validateFields().then(fieldsValue => {
        const params = {
          inboundCustomer: fieldsValue.inboundCustomer,
          inboundId: fieldsValue.inBoundName,
          outboundCustomer: fieldsValue.outboundCustomer,
          outboundId: fieldsValue.outBoundName,
          startTime: !fieldsValue.createDate[0] ? '' : moment(fieldsValue.createDate[0]).format('YYYY-MM-DD HH:mm:ss'),
          endTime: !fieldsValue.createDate[1] ? '' : moment(fieldsValue.createDate[1]).format('YYYY-MM-DD HH:mm:ss'),
        }
        messageManagementStore.searchMessageOverview(params, 1, PAGE_SIZE_DEFAULT)
      }).catch(err => {})
    } else if (tabsValue === 'identificationSearch') {
      this.formRef.current.validateFields().then(fieldsValue => {
        const params = {
          messageId: fieldsValue.messageId.length > 0 ? fieldsValue.messageId?.split(',') : [],
          requestId: fieldsValue.requestId.length > 0 ? fieldsValue.requestId?.split(',') : [],
          // sapMessageId: fieldsValue.sapMessageId.length>0?fieldsValue.sapMessageId.replace(/-/g,'')?.split(","):[],
        }
        messageManagementStore.searchMessageOverviewIdentification(params)
      }).catch(err => {})
    } else {
      this.formRef.current.validateFields().then(fieldsValue => {
        const params = {
          apiName: '',
          direction: '',
          messageStatus: '',
          indexName: fieldsValue.indexName,
          value: fieldsValue.value,
          startTime: !fieldsValue.createDateIndex[0] ? '' : moment(fieldsValue.createDateIndex[0]).format('YYYY-MM-DD HH:mm:ss'),
          endTime: !fieldsValue.createDateIndex[1] ? '' : moment(fieldsValue.createDateIndex[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        }
        messageManagementStore.searchMessageOverviewIndex(params, 1, PAGE_SIZE_DEFAULT)
      }).catch(err => {})
    }
  }
  /*export button*/
  handleExport = () => {
    const {messageManagementStore, uiState} = this.props
    const {searchItem, tabsValue} = messageManagementStore
    if (tabsValue === 'APIInformationSearch') {
      uiState.onChangeFetchingExport('/monitor/messageOverview/apiInformationSearch/export', searchItem, 'Message Overview List.xlsx')
    } else if (tabsValue === 'identificationSearch') {
      uiState.onChangeFetchingExport('/monitor/messageOverview/identificationSearch/export', searchItem, 'Message Overview List.xlsx')
    } else {
      uiState.onChangeFetchingExport('/monitor/messageOverview/indexSearch/export', searchItem, 'Message Overview List.xlsx')
    }
  }
  /*tabs change*/
  onChange = (value) => {
    const {messageManagementStore} = this.props
    messageManagementStore.changeTabsValue(value)
    if (value === 'APIInformationSearch') {
      const params = {
        startTime: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      messageManagementStore.searchMessageOverview(params, 1, PAGE_SIZE_DEFAULT)
      this.formRef.current.setFieldsValue({
        inboundCustomer: undefined,
        inBoundName: undefined,
        outboundCustomer: undefined,
        outBoundName: undefined,
        createDate: [moment().startOf('day'), moment().endOf('day')],
      })
    } else if (value === 'identificationSearch') {
      const params = {
        messageId: [],
        requestId: [],
        // sapMessageId: [],
      }
      messageManagementStore.resetOverviewList()
      // messageManagementStore.searchMessageOverviewIdentification(params,1, PAGE_SIZE_DEFAULT)
      this.formRef.current.setFieldsValue(params)
    } else {
      const params = {
        apiName: '',
        direction: '',
        messageStatus: '',
        indexName: undefined,
        value: '',
        startTime: moment().add('day', -6).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      messageManagementStore.searchMsgOverviewIndexName()
      messageManagementStore.searchMessageOverviewIndex(params, 1, PAGE_SIZE_DEFAULT)
      this.formRef.current.setFieldsValue({
        indexName: undefined,
        value: '',
        createDateIndex: [moment().add('day', -6).startOf('day'), moment().endOf('day')]
      })
    }
  }
  /*inboundCustomer*/
  onChangeInbound = (value) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onGetInboundNameAction(value)
    this.formRef.current.setFieldsValue({
      inBoundName: undefined
    })
    if (value === undefined) {
      this.setState({
        inboundValue: ''
      })
    } else {
      this.setState({
        inboundValue: value
      })
    }
  }
  /*outboundCustomer*/
  onChangeOutbound = (value) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onGetOutboundNameAction(value)
    this.formRef.current.setFieldsValue({
      outBoundName: undefined
    })
    if (value === undefined) {
      this.setState({
        outboundValue: ''
      })
    } else {
      this.setState({
        outboundValue: value
      })
    }
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {mappingManagementStore, messageManagementStore, searchParams, location, t} = this.props
    const {inboundCustomerList, inboundNameList, outboundCustomerList, outboundNameList} = mappingManagementStore
    const { tabsValue} = messageManagementStore
    /*input characters cannot exceed 1000 */
    // const checkMaxLength = (rule, value, callback) => {
    //   if (value !== undefined && value.length > 1000) {
    //     callback('The input content has exceeded 1000 characters！')
    //   } else {
    //     callback()
    //   }
    // }
    return (
      <>
        <Form ref={this.formRef} className="searchForm" layout={themeStyle?.layoutHorizontal ? "horizontal" : "vertical"}>

          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Tabs defaultActiveKey={searchParams?.tabsValue ? searchParams?.tabsValue : 'APIInformationSearch'} onChange={this.onChange}
                className="messagesTabs">
            <TabPane tab={t(`messageManagement.connectInfoSearch`)} key="APIInformationSearch" style={{paddingTop: 10}}>
              <Row gutter={[10, 0]}>
                <Col span={themeStyle?.layoutHorizontal ? 6 : 4}>

                  <Form.Item name="inboundCustomer" label={t(`messageManagement.inboundCustomer`)}
                             rules={[{message: `${t(`general.pleaseSelect`)} ${t(`messageManagement.inboundCustomer`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeInbound} showSearch
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                      {inboundCustomerList.length > 0 ? inboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                       value={item.id}>{item.customer}</Select.Option>) : null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={themeStyle?.layoutHorizontal ? 6 : 4}>

                  <Form.Item name="inBoundName" label={t(`messageManagement.inboundName`)}
                             rules={[{message: `${t(`general.pleaseSelect`)} ${t(`messageManagement.inboundName`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled={this.state.inboundValue === ''} showSearch
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                      {inboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={themeStyle?.layoutHorizontal ? 6 : 4}>

                  <Form.Item name="outboundCustomer" label={t(`messageManagement.outboundCustomer`)}
                             rules={[{message: `${t(`general.pleaseSelect`)} ${t(`messageManagement.outboundCustomer`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeOutbound} showSearch
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                      {outboundCustomerList.length > 0 ? outboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                         value={item.id}>{item.customer}</Select.Option>) : null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={themeStyle?.layoutHorizontal ? 6 : 4}>

                  <Form.Item name="outBoundName" label={t(`messageManagement.outboundName`)}
                             rules={[{message: `${t(`general.pleaseSelect`)} ${t(`messageManagement.outboundName`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled={this.state.outboundValue === ''} showSearch
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }>
                      {outboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={themeStyle?.layoutHorizontal ? 6 : 4}>

                  <Form.Item name="createDate" label={t(`messageManagement.timeRange`)}>
                    <RangePicker
                      allowClear={false}
                      showTime
                      format="YYYY-MM-DD HH:mm:ss"
                      style={{width: '100%'}}
                    />
                  </Form.Item>
                </Col>
                <Col offset={themeStyle?.layoutHorizontal ? 12 : 0} span={themeStyle?.layoutHorizontal ? 6 : 24} style={{textAlign: 'right', marginBottom: 10}}>
                  <Button onClick={() => this.handleSearch(tabsValue)} className="ant-btn-red">{t(`general.search`)}</Button>

                  <Button type="primary" onClick={this.handleExport} icon={<DownloadOutlined/>}>{t(`general.export`)}</Button>
                </Col>
              </Row>
            </TabPane>
            <TabPane tab={t(`messageManagement.identSearch`)} key="identificationSearch" style={{paddingTop: 10}}>
              <Row gutter={[10, 0]}>
                <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                  <Form.Item name="messageId" label={t(`messageManagement.messageId`)}
                             rules={[{
                               message: `${t(`general.pleaseEnter`)} ${t(`messageManagement.messageId`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^\s&|;\\]*$/)
                             }]}>
                    <TextArea rows={2} placeholder={t(`general.pleaseEnter`)} allowClear/>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                  <Form.Item name="requestId" label={t(`messageManagement.requestId`)}
                             rules={[{
                               message: `${t(`general.pleaseEnter`)} ${t(`messageManagement.requestId`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^\s&|;\\]*$/)
                             }]}>
                    <TextArea rows={2} placeholder={t(`general.pleaseEnter`)} allowClear/>
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                  <Form.Item name='sapMessageId' label="SAP Message ID"
                             rules={[{ message: 'Please enter SAP Message ID without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                    <TextArea rows={2} placeholder={t(`general.pleaseEnter`)} allowClear />
                  </Form.Item>
                </Col> */}
                <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6} style={{textAlign: 'right', marginTop: 30}}>
                  <Button onClick={() => this.handleSearch(tabsValue)} type='danger'>{t(`general.search`)}</Button>
                  <Button type="primary" onClick={this.handleExport} icon={<DownloadOutlined/>}>{t(`general.export`)}</Button>
                </Col>
              </Row>
            </TabPane>
            {/* <TabPane tab="Index Search" key="indexSearch" style={{paddingTop: 10}}>
            <Row gutter={[10,0]}>
                <Col span={4}>
                  <Form.Item name='indexName' label="Index Name"
                             rules={[{ required: tabsValue==='indexSearch', message: 'Please select Index Name.' }]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch>
                      {indexNames.length>0?indexNames.map(item => <Select.Option key={item} value={item}>{item}</Select.Option>):null}                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name='value' label="Index Value"
                             rules={[{ required: tabsValue==='indexSearch', message: 'Please enter Index Value without special characters.', pattern: new RegExp(/^[^\s&|;\\]*$/) }]}>
                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
                  <Form.Item name='createDateIndex' label='Time Range'>
                    <RangePicker
                      allowClear={false}
                      format="YYYY-MM-DD"
                      style={{width: '100%'}}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{textAlign: 'right'}}>
                  <Button onClick={()=>this.handleSearch(tabsValue)} type='primary'>Search</Button>
                  <Button type="primary" onClick={this.handleExport} icon={<DownloadOutlined />}>Export</Button>
                </Col>
              </Row>
            </TabPane> */}
          </Tabs>
        </Form>
      </>
    )
  }
}

export default withTranslation()(SearchForm)
